
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'the_location_and_common_diseases_of_abdominal_masses',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/the_location_and_common_diseases_of_abdominal_masses.vue